import { render, staticRenderFns } from "./pagerdutylicenses.vue?vue&type=template&id=835cb5ac&"
import script from "./pagerdutylicenses.vue?vue&type=script&lang=js&"
export * from "./pagerdutylicenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports